"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-cipriano-picentino": {
    "1143d34a": [{
      "hkey": "138061a0",
      "slug": "pezzano-filetta",
      "name": "Pezzano-Filetta",
      "primary": true,
      "skipSearch": false
    }],
    "filetta": [{
      "hkey": "138061a0",
      "slug": "pezzano-filetta",
      "name": "Pezzano-Filetta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;